import { css } from '@emotion/react';

const poweredByStyles = {
    poweredBy: css({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '33px',
    }),
    poweredByText: css({
        fontStyle: 'normal',
        fontSize: '10px',
        lineHeight: '11px',
        color: '#000000',
        maxWidth: '65%',
        textAlign: 'center',
    }),
    linksBox: css({
        marginTop: '6px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }),
    link: css({
        marginRight: '10px',
        fontSize: '10px',
    }),
    paymentsListContainer: css({
        marginTop: '12px',
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
    }),
};

export default poweredByStyles;
